import { forwardRef } from 'react';

export const CalendarIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8906 4.40625H18.0469V3H16.6406V4.40625H7.35938V3H5.95312V4.40625H5.10938C3.94627 4.40625 3 5.35252 3 6.51562V18.8906C3 20.0537 3.94627 21 5.10938 21H18.8906C20.0537 21 21 20.0537 21 18.8906V6.51562C21 5.35252 20.0537 4.40625 18.8906 4.40625ZM19.5938 18.8906C19.5938 19.2783 19.2783 19.5938 18.8906 19.5938H5.10938C4.72167 19.5938 4.40625 19.2783 4.40625 18.8906V9.60938H19.5938V18.8906ZM4.40625 8.20312H19.5938V6.51562C19.5938 6.12792 19.2783 5.8125 18.8906 5.8125H18.0469V7.21875H16.6406V5.8125H7.35938V7.21875H5.95312V5.8125H5.10938C4.72167 5.8125 4.40625 6.12792 4.40625 6.51562V8.20312Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.07812 11.0859H5.67188V12.4922H7.07812V11.0859ZM9.89062 11.0859H8.48438V12.4922H9.89062V11.0859ZM11.2969 11.0859H12.7031V12.4922H11.2969V11.0859ZM15.5156 11.0859H14.1094V12.4922H15.5156V11.0859ZM16.9219 11.0859H18.3281V12.4922H16.9219V11.0859ZM7.07812 13.8984H5.67188V15.3047H7.07812V13.8984ZM8.48438 13.8984H9.89062V15.3047H8.48438V13.8984ZM12.7031 13.8984H11.2969V15.3047H12.7031V13.8984ZM14.1094 13.8984H15.5156V15.3047H14.1094V13.8984ZM7.07812 16.7109H5.67188V18.1172H7.07812V16.7109ZM8.48438 16.7109H9.89062V18.1172H8.48438V16.7109ZM12.7031 16.7109H11.2969V18.1172H12.7031V16.7109ZM14.1094 16.7109H15.5156V18.1172H14.1094V16.7109ZM18.3281 13.8984H16.9219V15.3047H18.3281V13.8984Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
